<template >
  <div class="container-fluid">
  
    <div class="row justify-content-between p-3">
      <div class="col-8">
        <h3 class="h3">Асуултууд</h3>
        <button class="btn btn-sm btn-primary" v-if="display==0" @click="display=1">See all</button>
        <button class="btn btn-sm btn-primary" v-if="display==1" @click="display=0"> See only unchecked</button>

        <button class="ml-3 btn btn-sm btn-success" v-if="showAnswers!=true" @click="showAnswers=true">See answers</button>
        <button class="ml-3 btn btn-sm btn-success" v-else @click="showAnswers=false"> Hide answers</button>
      </div>


      
    </div>

    <!-- <vue-mathjax :formula="getLatexText()"></vue-mathjax> -->


    <div v-if="categories!=null && categories.length>0">
      <div v-for="(cat, index) in categories" v-bind:key="cat.id">
          <div class="row justify-content-between">
            <div class="col-10"><h3 class="m-0 font-weight-bold text-primary" style="font-size:14pt">{{index+1}}. {{cat.name}}</h3> </div>
            <!-- <div class="col col-md-auto"><i class="fas fa-trash" style="cursor:pointer" @click="deleteCategory(cat)"></i></div> -->
            <!-- <div class="col col-md-auto"><i
                class="fas fa-edit pr-5"
                @click="editCategory(cat)"
                style="cursor:pointer"
                data-toggle="Засаx"
                data-placement="bottom"
                title="Засаx"
              ></i>
            </div> -->
            
          </div>

 
          <hr/>
          <div v-if="cat.questions!=null && cat.questions.length>0">
            <div class="card shadow mb-4">
              <div class="card-body table-responsive">
                <table class="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th width="3%" scope="row">№</th>
                      <th >Асуулт</th>
                      <th width="5%">Асуултын дугаар</th>
                      <th width="10%">Оноо</th>
                      <th width="25%">Түлхүүр үгс</th>
                      <th width="5%" v-if="showAnswers!=true">Хариултын тоо</th>
                      <th width="25%" v-else>Хариултууд</th>
                      <th width="5%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(que, index) in cat.questions" v-if="(display==1) || (display==0 && que.checked!=true)">
                      <td scope="row">{{index+1}}.</td>
                      <td>
                        <!-- <span v-if="isLatex(que.title)==true">
   
                          <vue-mathjax :formula="getLatexText(que.title)"></vue-mathjax>
                  
                   
                        </span>
                        <span v-else>{{que.title}}</span> -->
                        <textarea name="text" wrap="soft" v-bind:rows="que.title!=null && que.title!=undefined && que.title.length>100 ? '10' : '0'"  v-model.trim="que.title" class="form-control" @change="updateTitle(cat, que, que.subquestions[0])"/>
                        <textarea name="text" wrap="soft" v-bind:rows="que.description!=null && que.description!=undefined && que.description.length>100 ? '10' : '0'"  v-model.trim="que.description" class="form-control" @change="updateDescription(cat, que, que.subquestions[0])"/>
                      </td>
                      <td>
                        <input type="number" min="1" v-model.number="que.index" class="form-control" @change="updateIndex(cat, que)"/>
                      </td>
                      <td>
                        <input v-if="que.subquestions[0].score>0" style="" type="number" min="1" v-model.number="que.subquestions[0].score" class="form-control" @change="updateScore(cat, que, que.subquestions[0])"/>
                        <input v-else style="background-color:red; color:white" type="number" min="1" v-model.number="que.subquestions[0].score" class="form-control" @change="updateScore(cat, que, que.subquestions[0])"/>
                      </td>
                      <td>
                        <div class="form-group">
                          <div class="row">
                            <div class="col">
                              
                              <input v-model.trim="que.tagText" v-on:keyup.enter="addTag(que, que.tagText)" type="text" class="form-control" placeholder="тригонометр, функц">
                            </div>
                  
                          </div>
                          <div>
                            <span class="badge badge-pill badge-success mr-2" v-for="(tag, ti) in que.tags">
                              {{tag}}
                              <i class="fas fa-times ml-2" style="cursor:pointer" @click="removeTag(que, tag, ti)"></i>
                            </span>
                          </div>
                        </div>
                      </td>
                      <td v-if="showAnswers!=true">
                        <span v-if="que.subquestions[0]!=null && que.subquestions[0].answers!=null && que.subquestions[0].answers.length>0">{{que.subquestions[0].answers.length}}</span>
                        <span v-else class="text-danger">0</span>
                        <br/>
                        <span class="badge badge-success" v-if="checkAnswerSelected(que.subquestions[0])==true">Зөв хариулт сонгосон</span>
                        <span class="badge badge-danger" v-else>Зөв хариулт сонгоогүй</span>
                      </td>
                      <td v-else>
                        
                        <div v-if="que.subquestions[0].answers!=null && que.subquestions[0].answers.length>0" >
                          <div class="row my-3 m-0 p-0"  v-for="(answer,index) in que.subquestions[0].answers" v-bind:key="'answer_'+index">
                            <div class="col col-8 m-0">
                              <textarea @change="updateAnswer(cat, que, que.subquestions[0], answer)" v-model.trim="answer.name" type="text" class="form-control" placeholder="Хариулт"/>
                            </div>
                            <div class="col col-2 m-0">
                                  <div class="form-check">
                                  <input type="checkbox" class="form-check-input"  v-model="answer.correct" @change="updateAnswer(cat, que, que.subquestions[0], answer)" >
                                  <label class="form-check-label" for="exampleCheck1">Зөв</label>
                                </div>
                            </div>
                            <!-- <div class="col col-2">
                                <i class="fas fa-trash text-danger text-small" style="cursor:pointer" @click="remove(index, subquestion)"></i>
                                Устгаx
                            </div> -->
                          </div>
                        </div>
                        <div v-else class="alert alert-danger">Одоогоор хариулт оруулаагүй байна.</div>

                      </td>
                      <td>
                        <button v-if="que.checked!=true" @click="checked(que)" class="btn btn-danger btn-sm">шалгасан</button>

                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- <button class="btn btn-success">Хадгалах</button> -->
              </div>
            </div>
    
          </div>
      </div>
    </div> 


  </div>
</template>

<script>
const fb = require("../../firebaseConfig.js");
import { mapState } from "vuex";
import moment from "moment";
import BarChart from "../BarChart.js";
import { stat } from "fs";
import {VueMathjax} from 'vue-mathjax'
import latexmixin from '../global/latex.js';
var colors=[
  "#00E396",
  "#FEB019",
  "#FF4560",
  "#775DD0",
  "#546E7A",
  "#26a69a",
  "#D10CE8"
];
export default {
  name: "QuestionsScore",
  components: {
    'bar-chart': BarChart,
    'vue-mathjax': VueMathjax
  },
  mixins: [latexmixin],
  data() {
    return {
      showAnswers:false,
      display:0,
      selectedCategory: null,
      categories: [],
      questions: [],
      content:null,
      formula: '\(x = {-b \\pm \\sqrt{b^2-4ac} \\over 2a}.\)',
      options: {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          xAxes: [
            {
              ticks: {
                userCallback: function(label, index, labels) {
                  if (typeof label === "string" && label.length > 10) {
                    return label.substring(0, 20) + " ...";
                  }
                  return label;
                }
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      },
      statData: {
        chartOptions: {
          chart: {
            id: "basic-bar"
          },
          colors: colors,
          labels: {
            show: true,
            hideOverlappingLabels: false
          },
          plotOptions: {
            bar: {
              distributed: true,
              horizontal: true,
              endingShape: "rounded"
            }
          }
          // plotOptions: {
          //     bar: {
          //     horizontal: false,
          //     columnWidth: '55%',
          //     endingShape: 'rounded'
          //     },
          // },
        },
        series: [
          {
            name: "series-1",
            data: [
              {
                x: "Apple",
                y: 54
              },
              {
                x: "Orange",
                y: 66
              }
            ]
          }
        ]
      }
    };
  },
  methods: {
    
    _getQA() {
      fb.db
        .collection("lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId+"/questions").orderBy("createdAt","asc")
        .onSnapshot(querySnapshot => {
          this.questions = [];
          querySnapshot.forEach(doc => {
             let question=doc.data();
              question.id=doc.id;
              question.subquestions=[];
              question.tagText=null;

              doc.ref.collection("subquestions").get().then(subDocs=>{
                subDocs.forEach((subquestion, index)=> {
                    let object=subquestion.data();
                    object.id = subquestion.id;
                    object.answers=[];
   
                    if(object.answertype==true){
                      object.useranswers=[]
                      this._getQuestionAnswers(object, subquestion.ref);
                    }
                    else{
                      object.answers = [];
                      this._getAnswers(object, subquestion.ref);
                    }

                    question.subquestions.push(object);

                });
              });

              this.questions.push(question);
          });
        });
    },
    _getAnswers(question, ref) {
      if (question.answers == null || question.answers == undefined)
        question.answers = [];
      ref
        .collection("answers")
        .orderBy("index", "asc")
        .get().then(querySnapshot => {
          question.answers = [];
    
          let index = 0;
          querySnapshot.forEach(doc => {
            let answer = doc.data();
            answer.id = doc.id;
           
            question.answers.push(answer);
            index++;
          });
       
        });
    },
    _getQuestionAnswers(question, ref){
      ref.collection("votedusers").get().then(querySnapshot=>{
        querySnapshot.forEach(doc => {
          let answer = doc.data();
          answer.id = doc.id;
          question.useranswers.push(answer);
        });
      });
    },
  
    
    deleteQuestion(question){
       var result = confirm("Та устгаxыг xүсэж байна уу? : "+ question.id + " " + question.category);
        if (result) {
            if(question!=null && question.category!=null && question.id!=null) {

              this.categories.forEach(cat =>{
                if(cat.id == question.category) {
                  
              fb.db.collection("asuulga").doc(this.qaId).collection("categories").doc(question.category).
              collection("questions").doc(question.id).delete()
                  cat.questions.splice(question);
                }
              })
            }
        }
    },
   
 
    _setLabel(questionId, status, field, category) {
      var tmp = {};
      tmp[field] = status;
      if(category==null || (category!=null && category.id==null))
        fb.db
          .doc("lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.detailId)
          .collection("questions")
          .doc(questionId)
          .update(tmp);
      else{
        fb.db
          .doc("lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.detailId+'/tests/'+category.id)
          .collection("questions")
          .doc(questionId)
          .update(tmp);
      }
    },
    _setPublishedContent(status) {
      fb.db
        .doc("lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.detailId)
        .update({'published':status});
      this.content.published=status;
     
    },
    _getQuestionsOfCategory(cat, catRef){
      catRef
        .collection("questions").orderBy("createdAt","asc").get().then(querySnapshot =>{
          cat.questions=[];
          querySnapshot.forEach(doc => {

              let question=doc.data();
              question.id=doc.id;
              question.subquestions=[];
              question.path=doc.ref.path;
              question.tagText=null;
              if(question.checked==undefined)
                question.checked=false;

              doc.ref.collection("subquestions").get().then(subDocs=>{
                question.subquestions=[];
                subDocs.forEach((subquestion, index)=> {
                    let object=subquestion.data();
                    object.id = subquestion.id;
                    object.answers=[];
   
                    if(object.answertype==true){
                      // object.useranswers=[]
                      // this._getQuestionAnswers(object, subquestion.ref);
                    }
                    else{
                      object.answers = [];
                      this._getAnswers(object, subquestion.ref);
                    }

                    question.subquestions.push(object);

                });

              cat.questions.push(question);
            })
          });
        });
    },
    _calcTotal(){
      var total=0;
      this.categories.forEach((cat)=>{
        cat.questions.forEach((question)=>{
          question.subquestions.forEach((sub)=>{
            if(sub!=null && sub.score!=null && sub.score!=undefined && sub.score!='')
              total+=sub.score;
          });
        });
      });
      fb.db.doc("lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId).update({'totalScore': total});

    },
    _findCategories(){


      fb.db
        .collection("lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId+"/tests").orderBy("createdAt","asc")
        .onSnapshot(querySnapshot => {
          this.categories = [];
          querySnapshot.forEach(doc => {
            let cat = doc.data();
            cat.id = doc.id;
            cat.questions=[]
            this._getQuestionsOfCategory(cat, doc.ref)
            this.categories.push(cat);
          });
        });

      this.categories.push({name:'--no group--', id:'null'});

    },
  
    getContent(){
      fb.db.doc("lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.detailId).onSnapshot(detailDoc=>{
        if(detailDoc.exists){
          let detail=detailDoc.data();
          detail.id=detailDoc.id;
          this.content=detail;
        }
      });
    },
    getLtx(text){
      this.$nextTick(() => {

      })
    },
    async updateScore(cat, question, subquestion){
      await fb.db
        .doc("lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId+"/tests/"+cat.id+"/questions/"+ question.id+"/subquestions/"+subquestion.id).update({
          "score": subquestion.score
        });
      this._calcTotal();
    },
    async updateTitle(cat, question, subquestion){
      await fb.db
        .doc("lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId+"/tests/"+cat.id+"/questions/"+ question.id).update({
          "title": question.title
        });
      await fb.db
        .doc("lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId+"/tests/"+cat.id+"/questions/"+ question.id+"/subquestions/"+subquestion.id).update({
          "title": question.title
        });
    },
    async updateDescription(cat, question, subquestion){
      await fb.db
        .doc("lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId+"/tests/"+cat.id+"/questions/"+ question.id).update({
          "description": question.description
        });
      await fb.db
        .doc("lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId+"/tests/"+cat.id+"/questions/"+ question.id+"/subquestions/"+subquestion.id).update({
          "description": question.description
        });
    },
    async updateIndex(cat, question){
      await fb.db
        .doc("lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId+"/tests/"+cat.id+"/questions/"+ question.id).update({
          "index": question.index
        });
    },
    addTag(question, tag){
      if(tag!=null && tag!=undefined){
        if(question.tags==null || question.tags==undefined)
          question.tags=[];
        if(!question.tags.includes(tag) && question.path!=undefined && question.path!=null){
          question.tags.push(tag);
          fb.db.doc(question.path).update(
            {"tags":fb.firestore.FieldValue.arrayUnion(tag)}
          );
        }
        question.tagText=null;
      }
    },
    removeTag(question, tag, index){
      if(tag!=null && tag!=undefined)
        if(question.tags.includes(tag) && question.path!=undefined && question.path!=null){
          question.tags.splice(index, 1);
          fb.db.doc(question.path).update(
            {"tags":fb.firestore.FieldValue.arrayRemove(tag)}
          );
        }
      },

    async checked(question){
      if( question.path!=undefined && question.path!=null){
        await fb.db.doc(question.path).update({"checked":true});
        question.checked=true;
      }
    },
    checkAnswerSelected(subquestion){
      var result=false;
      if(subquestion!=null && subquestion.answers){
        for(const answer of subquestion.answers){
          if(answer!=null && answer!=undefined && answer.correct==true){
            result=true;
            break;
          }
        }
      }
      return result;
    },
    async updateAnswer(cat, question, subquestion, answer){
      await fb.db
        .doc("lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId+"/tests/"+cat.id+"/questions/"+ question.id+"/subquestions/"+subquestion.id+"/answers/"+answer.id).update(answer);
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"])
  },

  props: {
    lessonId: {
      required: true
    },
    topicId: {
      required: true
    },
    detailId: {
      required: true
    }
  },
  created() {
    if(this.lessonId!=null && this.lessonId!='' && this.topicId!=null && this.topicId!='' && this.detailId!=null && this.detailId!='' ){
      this._findCategories();
      this.getContent();
    }
    
  },
  filters: {
    formatDate(val) {
      if (val != null) {
        if (!val) {
          return "-";
        }
        let date = val.toDate();
        return moment(date).fromNow();
      }
      return "-";
    }
  }
};
</script>

<style>
  .panel-body >.list-group{
      max-height: 350px;
      margin-bottom: 10px;
      overflow-y:auto;
      -webkit-overflow-scrolling: touch;
  }
</style>
